import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWritePhysicalInformation: Map<string, ConfirmationData> = new Map([
    ["9b65fd68-c0db-402f-aa1b-281b083c1ece", { hidden: true }],
    ["78905547-2b78-4bf2-965e-a5a088881bb8", { hiddenAll: true }],
    ["3dfb2547-82ff-491d-a240-18211b6ac4cf", { hidden: true }],
    ["10e51fe4-d766-41cd-af5f-b8f5dc4118b8|4ce75734-5023-4c15-a37e-0004de0d83e5", { label: "Peso em quilogramas" }],
    ["86b0b60a-9102-4a9c-aff8-d2b263125d34|2a72a640-b4ac-40dd-8e45-94aa9f07da9f", { label: "Altura em metros" }],
    
    ["83eb9c11-a0a4-4289-a7f3-ea5cd73d6109", { hidden: true }],
    ["9ea11690-e0a8-4df4-ae2e-adec0a8e969b", { hidden: true }],
    ["020fc0c0-16bc-40f4-bbee-f6a5983a9d3a|35ba1e0f-cab1-4433-8b5e-765037412c17", { fontWeight: "bold" }],
    ["9d3bb11f-30e2-4e31-9898-3a674beec720|85f3635f-f958-4554-b731-f216e28fbf9a", { fontWeight: "bold" }],
    
]);



